import { ThemeProvider } from '@mui/material'
import { BetSlip } from 'components/organisms'
import { BetContextProvider } from 'contexts/BetContext'
import { TranslationContextProvider } from 'contexts/TranslationContext'
import 'styles/fonts.css'
import { betinTheme } from 'styles/theme'

function App() {
    return (
        <ThemeProvider theme={betinTheme}>
            <TranslationContextProvider>
                <BetContextProvider>
                    <BetSlip />
                </BetContextProvider>
            </TranslationContextProvider>
        </ThemeProvider>
    )
}

export default App
